import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AddToCartButton from '../../ui_add-to-cart-button/component';
import PriceBlock from '../../base_price-block/component';
import Image from '../../base_image/component';
import Icon from '../../base_svg-icon/component';
import Dropdown from '../../ui_dropdown/component';
import { getOffset, scrollTo } from '@utils';

import './styles/styles.scss';

/*
 * TODO:
 *  - Add Bruna details icon from icomoon and call it ico-details
 * - Add ico comment to Bruna
 *  - Add "more" button to Bruna and make sure it works as desired
 *
 */

/**
 * Product description page sub navigation
 */
class PdpNaviMenu extends Component {
  constructor(props) {
    super(props);
    const anchors = this.generateAnchors();

    this.state = {
      anchors,
      anchorsBase: null,
      anchorsRest: null,
      sticky: false,
      dropdownOpen: false,
      activeLi: '',
    };

    this.fauxFilter = React.createRef();
    this.updateBreakNumber = this.updateBreakNumber.bind(this);
    this.stickyCheck = this.stickyCheck.bind(this);
    this.toglleDropdown = this.toglleDropdown.bind(this);
    this.scrollspy = this.scrollspy.bind(this);
    this.smoothScroll = this.smoothScroll.bind(this);
    this.updateHeight = this.updateHeight.bind(this);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateBreakNumber);
    this.updateBreakNumber();

    window.addEventListener('scroll', this.stickyCheck);
    document.body.addEventListener('scroll', this.stickyCheck, false);
    window.addEventListener('resize', this.stickyCheck);
    this.stickyCheck();

    // scroll spy
    window.addEventListener('scroll', this.scrollspy);
    window.addEventListener('resize', this.scrollspy);

    // add observer
    this.observeAnchors();

    // set height
    window.addEventListener('load', this.updateHeight);
    this.updateHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateBreakNumber);
    window.removeEventListener('scroll', this.stickyCheck);
    document.body.removeEventListener('scroll', this.stickyCheck);
    window.removeEventListener('resize', this.stickyCheck);
    window.removeEventListener('scroll', this.scrollspy);
    window.removeEventListener('resize', this.scrollspy);
    window.removeEventListener('load', this.updateHeight);
    this.anchorObserver && this.anchorObserver.disconnect();
  }

  /**
   * Set the heights of components based on the rendered layout
   */
  updateHeight() {
    if (this.fauxFilter.current) {
      this.barOriginalHeight = this.fauxFilter.clientHeight || 90; // set the original height fixed to a attribute
      this.fauxFilter.current.style.height = `${this.barOriginalHeight}px`;
    }
  }

  observeAnchors() {
    this.anchorObserver = new MutationObserver(((mutations) => {
      // Re-generate anchors after mutation
      mutations.forEach((mutation) => {
        let anchors = this.generateAnchors();

        /**
         * When the localized keys are fetched, the anchors title should be updated
         */
        if (mutation.attributeName === 'title') {
          const updatedAnchor = this.state.anchors.filter(anchor => anchor.href === `#${mutation.target.id}`)[0];
          const otherAnchors = this.state.anchors.filter(anchor => anchor.href !== `#${mutation.target.id}`);

          updatedAnchor.title = mutation.target.title;
          anchors = [...otherAnchors, updatedAnchor];
        }

        this.setState({ anchors });
        this.updateBreakNumber();
      });
    }));

    // attach the observer to all the target anchors
    const config = { attributes: true };
    for (const elm of this.props.anchorDomElements) {
      this.anchorObserver.observe(elm, config);
    }
  }

  get headerHeight() {
    const { store } = this.props;
    const masthead = document.querySelector('.masthead');

    if (!store.headerHeight && masthead) {
      return store.update('headerHeight', masthead.clientHeight);
    }

    return store.headerHeight || 102;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sticky !== this.state.sticky) {
      this.updateBreakNumber();
    }
  }

  /**
   * Generate the links to be used in the nav bar
   * bassed on the target anchors in the dom
   *
   * @param anchorDomElements
   * @returns {Array}
   */
  generateAnchors() {
    const { anchorDomElements } = this.props;
    // Start with overzicht
    const anchors = [
      { title: 'Overzicht', iconClass: 'ico-book-closed', href: '#top' },
    ];
    anchorDomElements.forEach((elm) => {
      if (!elm) {
        return;
      }
      const anchor = {
        title: elm.title,
        iconClass: elm.getAttribute('data-icon'),
        href: `#${elm.id}`,
      };
      if (elm.getAttribute('data-iconSubClass')) {
        anchor.iconSubClass = elm.getAttribute('data-iconSubClass');
      }
      if (elm.getAttribute('data-iconSubContent')) {
        anchor.iconSubContent = elm.getAttribute('data-iconSubContent');
      }
      if (!elm.hasAttribute('hidden')) {
        anchors.push(anchor);
      }
    });

    return anchors;
  }

  /**
   * Dropdown the rest of the items in the bar (if they don't fit on the bar)
   * @param e
   */
  toglleDropdown(e) {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
    e.preventDefault();
  }

  /**
   * If the link is to a hash on the site
   * Smooth scroll to it, if posible update the url bar to match the hash
   *
   * @param e
   */
  smoothScroll(e) {
    const {  currentTarget } = e;
    const { hash } = currentTarget;
    if (e.currentTarget.hash && window.requestAnimationFrame) {
      e.preventDefault();

      // update hash if posible
      if (history.pushState) {
        history.pushState(null, null, hash);
      }
      const target = (hash === '#top') ? document.body : document.querySelector(hash);
      const { top } = getOffset(target);
      scrollTo({ top, behavior: 'smooth' });
    }

    this.setState({
      dropdownOpen: false,
    });
  }

  scrollspy() {
    let activeElement;
    for (const elm of this.props.anchorDomElements) {
      if (elm && elm.offsetParent !== null && elm.getBoundingClientRect().top < 10) { // 10 is offset
        activeElement = elm;
      }
    }
    if (activeElement) {
      this.setState({ activeLi: `#${activeElement.id}` });
    } else {
      this.setState({ activeLi: `#top` });
    }
  }

  stickyCheck() {
    const sticky = (this.fauxFilter.current.getBoundingClientRect().top < this.headerHeight);
    this.setState({
      sticky,
    });
  }

  updateBreakNumber() {
  /*
   *  TODO: do this without expensive calculations
   */
    const width = this.fauxFilter.current.offsetWidth;

    let breakAfter;
    if (width >= 1200) {
      breakAfter = 7;
    } else if (width >= 1000) {
      breakAfter = 6;
    } else if (width >= 780) {
      breakAfter = 4;
    } else if (width >= 550) {
      breakAfter = 4;
    } else {
      breakAfter = 4;
    }
    this.setState({
      anchorsBase: this.state.anchors.slice(0, breakAfter),
      anchorsRest: this.state.anchors.slice(breakAfter),
    });
  }

  getMainLis() {
    return this.state.anchorsBase?.map((anchor, i) => {
      const activeClass = (this.state.activeLi === anchor.href) ? 'active' : '';
      return (
        <li key={anchor.href + i}>
          <a onClick={this.smoothScroll}
            className={`pdp-menu-item ${activeClass}`}
            href={anchor.href}
            data-link={anchor.href}
            data-test-id={`pdp-menu-item-${anchor.title.toLowerCase()}`}
          >
            <Icon
              name={anchor.iconClass}
              size={200}
              direction="column"
            >
              {anchor.title}
            </Icon>
          </a>
        </li>
      );
    });
  }
  /*
   * Returns the items under the "more" tab.. If there are too many tabs
   *
   */
  getRestLis() {
    return this.state.anchorsRest?.map((anchor, i) => {
      const activeClass = (this.state.activeLi === anchor.href) ? 'active' : '';
      return (
        <li key={anchor.href + i}>
          <a onClick={this.smoothScroll} className={`pdp-menu-item ${activeClass}`} href={anchor.href}
            data-link={anchor.href}>
            <Icon
              name={anchor.iconClass}
              size={150}
              direction="row"
            >
              {anchor.title}
            </Icon>
          </a>
        </li>
      );
    });
  }

  render() {
    const { product = {}, store } = this.props;
    const stickyClass = this.state.sticky ? 'state-break' : '';
    const positionTop = this.state.sticky ? this.headerHeight : '0';
    return (
      <div
        className="pdp-menu-placeholder hidden-xs"
        ref={this.fauxFilter}
        style={{ position: 'relative' }}
        data-test-id={'comp-pdpNaviMenu'}
      >
        <div
          id="pdp-menu"
          className={`pdp-menu hidden-xs ${stickyClass}`}
          style={{ top: positionTop }}
        >
          <div className="panel-body">
            <div className="container">

              <ul className="pdp-menu-items">
                {this.getMainLis()}
                {!!this.state.anchorsRest?.length > 0 && (
                  <li className="pdp-menu-dropdown">
                    <Dropdown label={(
                      <>
                        <span>Meer</span>
                        <Icon name="ico-arrow-down" size={87} />
                      </>
                    )}>
                      {this.getRestLis()}
                    </Dropdown>
                  </li>
                )}
              </ul>

              <div className="pdp-menu-extra">
                <Image src={product.image} alt={product.name}/>
                {product.isOnline && (
                  <PriceBlock store={store} product={product} size="medium" onePrice noStyling/>
                )}
                {product.showAddToCartButton && (
                  <AddToCartButton product={product} store={store} showQuantity={false} size="small" smallIcon={true}/>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

PdpNaviMenu.propTypes = {

  /**
   * Call to action
   */
  cta: PropTypes.shape({
    /**
     * The url for adding it in to your cart and showing the cart.
     */
    href: PropTypes.string,
    /**
     * The actual action,
     * Ajax call for adding the product to the cart.
     */
    url: PropTypes.string,
    /**
     * Popup url after you add the product to the cart
     */
    notificationurl: PropTypes.string,
    /**
     * Used for tagmanager
     */
    product: PropTypes.string,
    /**
     *  Type of action (add, viewAndPromo)
     */
    type: PropTypes.string,
    /**
     * Panel type e.g. 'sidepanel-content-secondhand'
     */
    showpanel: PropTypes.string,
    /**
     * Unknown
     */
    promo: PropTypes.string,
    /**
     * Used for a E-book to open a popup in stead of a panel for the cta message
     */
    aditionalClasses: PropTypes.string,
    name: PropTypes.string,
  }),

  /**
   * All data is in the anchors.
   * The Anchors are an array of links for the submenu
   * type = nodeList
   */
  anchorDomElements: PropTypes.any.isRequired,
  store: PropTypes.object,
  product: PropTypes.object,
};

export default PdpNaviMenu;
